export default () => {
  const data = {
    event_name: 'tapped_text_field',
    button_name: 'city',
    page_section: 'filter_section',
    name_of_the_page_viewed: 'development_list_personal',
  };
  return data;
};
